import CounterpartySearchResult from './CounterpartySearchResult';

export default CounterpartySearchResult;
